// Structured enums with built-in translations
const COUNTRIES = {
    ITALY: {
        en: 'Italy',
        ua: 'Італія',
        es: 'Italia',
        ru: 'Италия'
    },
    UZBEKISTAN: {
        en: 'Uzbekistan',
        ua: 'Узбекистан',
        es: 'Uzbekistán',
        ru: 'Узбекистан'
    },
    CRIMEA: {
        en: 'Crimea',
        ua: 'Крим',
        es: 'Crimea',
        ru: 'Крым'
    }
};

const CUISINE_TYPES = {
    DESSERT: {
        en: 'Dessert',
        ua: 'Десерт',
        es: 'Postre',
        ru: 'Десерт'
    },
    MAIN: {
        en: 'Main Course',
        ua: 'Основна страва',
        es: 'Plato Principal',
        ru: 'Основное блюдо'
    },
    STREET_FOOD: {
        en: 'Street Food',
        ua: 'Вулична їжа',
        es: 'Comida Callejera',
        ru: 'Уличная еда'
    }
};

const RECIPE_TYPES = {
    VEGETARIAN: {
        en: 'Vegetarian',
        ua: 'Вегетаріанський',
        es: 'Vegetariano',
        ru: 'Вегетарианский'
    },
    MEAT: {
        en: 'Meat',
        ua: 'М\'ясний',
        es: 'Carne',
        ru: 'Мясной'
    }
};

const KITCHEN_MATERIALS = {
    MIXING_BOWL: {
        en: 'Mixing bowl',
        ua: 'Миска для змішування',
        es: 'Tazón de mezcla',
        ru: 'Миска для смешивания'
    },
    WHISK: {
        en: 'Whisk',
        ua: 'Віночок',
        es: 'Batidor',
        ru: 'Венчик'
    },
    BAKING_DISH: {
        en: 'Baking dish',
        ua: 'Форма для випікання',
        es: 'Fuente para hornear',
        ru: 'Форма для выпечки'
    },
    LARGE_POT: {
        en: 'Large pot',
        ua: 'Велика каструля',
        es: 'Olla grande',
        ru: 'Большая кастрюля'
    },
    WOODEN_SPOON: {
        en: 'Wooden spoon',
        ua: 'Дерев\'яна ложка',
        es: 'Cuchara de madera',
        ru: 'Деревянная ложка'
    },
    ROLLING_PIN: {
        en: 'Rolling pin',
        ua: 'Качалка',
        es: 'Rodillo',
        ru: 'Скалка'
    },
    FRYING_PAN: {
        en: 'Frying pan',
        ua: 'Сковорода',
        es: 'Sartén',
        ru: 'Сковорода'
    }
};

const CHEFS = {
    ANDREW_BAKUROV: {
        en: 'Andrew Bakurov',
        ua: 'Андрій Бакуров',
        es: 'Andrew Bakurov',
        ru: 'Андрей Бакуров'
    },
    NATALIA_BAKUROVA: {
        en: 'Natalia Bakurova',
        ua: 'Наталія Бакурова',
        es: 'Natalia Bakurova',
        ru: 'Наталия Бакурова'
    },
    SERHII_SHUMEIKO: {
        en: 'Serhii Shumeiko',
        ua: 'Сергій Шумейко',
        es: 'Serhii Shumeiko',
        ru: 'Сергей Шумейко'
    },
    TETIANA_SHUMEIKO: {
        en: 'Tetiana Shumeiko',
        ua: 'Тетяна Шумейко',
        es: 'Tetiana Shumeiko',
        ru: 'Татьяна Шумейко'
    },
    ILLYA_BAKUROV: {
        en: 'Illya Bakurov',
        ua: 'Ілля Бакуров',
        es: 'Illya Bakurov',
        ru: 'Илья Бакуров'
    },
    LIDIA_BAKUROVA: {
        en: 'Lidia Bakurova',
        ua: 'Лідія Бакурова',
        es: 'Lidia Bakurova',
        ru: 'Лидия Бакурова'
    },
    LEONID_BAKUROV: {
        en: 'Leonid Bakurov',
        ua: 'Леонід Бакуров',
        es: 'Leonid Bakurov',
        ru: 'Леонид Бакуров'
    },
    ARTEM_BAKUROV: {
        en: 'Artem Bakurov',
        ua: 'Артем Бакуров',
        es: 'Artem Bakurov',
        ru: 'Артем Бакуров'
    }
};

// UI Translations
const UI_TRANSLATIONS = {
    en: {
        back: 'Back',
        home: 'Home',
        prep: 'Prep',
        cook: 'Cook',
        kcal: 'Kcal',
        protein: 'Proteins',
        carbs: 'Carbs',
        fat: 'Fats',
        servings: 'Servings',
        ingredients: 'Ingredients',
        instructions: 'Instructions',
        materials: 'Materials',
        video: 'Video',
        gallery: 'Gallery',
        filters: 'Filters',
        clearAll: 'Clear All',
        cuisine: 'Cuisine',
        recipeType: 'Recipe Type',
        author: 'Author',
        noNutritionInfo: 'No nutrition info available',
        recipeNotFound: 'Recipe not found.',
        months: [
            'January', 'February', 'March', 'April', 'May', 'June',
            'July', 'August', 'September', 'October', 'November', 'December'
        ]
    },
    ua: {
        back: 'Назад',
        home: 'Головна',
        prep: 'Підготовка',
        cook: 'Приготування',
        kcal: 'Ккал',
        protein: 'Білки',
        carbs: 'Вуглеводи',
        fat: 'Жири',
        servings: 'Порцій',
        ingredients: 'Інгредієнти',
        instructions: 'Інструкції',
        materials: 'Матеріали',
        video: 'Відео',
        gallery: 'Галерея',
        filters: 'Фільтри',
        clearAll: 'Очистити все',
        cuisine: 'Кухня',
        recipeType: 'Тип рецепту',
        author: 'Автор',
        noNutritionInfo: 'Інформація про харчування недоступна',
        recipeNotFound: 'Рецепт не знайдено.',
        months: [
            'січня', 'лютого', 'березня', 'квітня', 'травня', 'червня',
            'липня', 'серпня', 'вересня', 'жовтня', 'листопада', 'грудня'
        ]
    },
    es: {
        back: 'Atrás',
        home: 'Inicio',
        prep: 'Preparación',
        cook: 'Cocción',
        kcal: 'Kcal',
        protein: 'Proteínas',
        carbs: 'Carbohidratos',
        fat: 'Grasas',
        servings: 'Porciones',
        ingredients: 'Ingredientes',
        instructions: 'Instrucciones',
        materials: 'Materiales',
        video: 'Video',
        gallery: 'Galería',
        filters: 'Filtros',
        clearAll: 'Limpiar Todo',
        cuisine: 'Cocina',
        recipeType: 'Tipo de Receta',
        author: 'Autor',
        noNutritionInfo: 'Información nutricional no disponible',
        recipeNotFound: 'Receta no encontrada.',
        months: [
            'enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio',
            'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'
        ]
    },
    ru: {
        back: 'Назад',
        home: 'Главная',
        prep: 'Подготовка',
        cook: 'Приготовление',
        kcal: 'Ккал',
        protein: 'Белки',
        carbs: 'Углеводы',
        fat: 'Жиры',
        servings: 'Порций',
        ingredients: 'Ингредиенты',
        instructions: 'Инструкции',
        materials: 'Материалы',
        video: 'Видео',
        gallery: 'Галерея',
        filters: 'Фильтры',
        clearAll: 'Очистить все',
        cuisine: 'Кухня',
        recipeType: 'Тип рецепта',
        author: 'Автор',
        noNutritionInfo: 'Информация о питании недоступна',
        recipeNotFound: 'Рецепт не найден.',
        months: [
            'января', 'февраля', 'марта', 'апреля', 'мая', 'июня',
            'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'
        ]
    }
};

export {
    COUNTRIES,
    CUISINE_TYPES,
    RECIPE_TYPES,
    KITCHEN_MATERIALS,
    CHEFS,
    UI_TRANSLATIONS
}; 